import { apiClient } from "./client";

/**
 * Reporta un error de renderizado del frontend al backend (observabilidad
 * de plataforma — resuelve el TODO histórico de `ErrorBoundary.tsx`).
 * Deliberadamente nunca lanza: si el reporte mismo falla (red caída,
 * backend abajo, etc.) no debe generar un segundo error para un usuario
 * que ya está viendo la pantalla de error. Funciona tanto autenticado como
 * no autenticado — `apiClient` adjunta el token si existe, y el backend
 * acepta la solicitud en ambos casos.
 */
export function reportClientError(error: Error, componentStack?: string): void {
  void apiClient
    .post("/client-errors", {
      message: error.message || "Error desconocido",
      stack: error.stack,
      componentStack,
      url: window.location.href,
    })
    .catch(() => {
      // Silencioso a propósito: reportar el error nunca debe convertirse en un error nuevo.
    });
}
